/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getUnreadCounts() {
    return axios.get(`${this.url}/unread_counts`);
  }

  forwardMessage(conversationId, messageId, payload) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/forward`,
      payload
    );
  }

  fetchWhatsappGroups(inboxId) {
    return axios.get(`${this.baseUrl()}/inboxes/${inboxId}/whatsapp_groups`);
  }

  fetchWhatsappContacts(inboxId) {
    return axios.get(`${this.baseUrl()}/inboxes/${inboxId}/whatsapp_contacts`);
  }

  searchContacts(q) {
    return axios.get(`${this.baseUrl()}/contacts/search`, {
      params: { q, page: 1, sort: 'name' },
    });
  }

  listContacts() {
    return axios.get(`${this.baseUrl()}/contacts`, {
      params: { page: 1, sort: 'name' },
    });
  }
}

export default new ConversationApi();
